import styled from "styled-components/macro";
import { sizes } from "../../../styles/variables";

export const Container = styled.main`
  margin: auto;
  max-width: ${sizes.mainMaxWidth};
  padding: 0 21px;
`;
